import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IconButton, Menu, MenuItem, TableCell } from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { red } from "@mui/material/colors";
import DeleteUser from "./DeleteUser";
import EditUser from "./EditUser";
import { StyledTableRow } from "../customComponent";
import {
  SET_ERROR_MESSAGE_USER_PAGE,
  SET_ERROR_PROMPT_USER_PAGE,
} from "../../store/actionTypes/userActionType";
import ForceLogoutUser from "./ForceLogoutUser";
import Role from "../../helpers/roles";
import { colorStyling } from "../../helpers/color";

const UserItem = ({ user, index, userRole, userPermission }) => {
  const dispatch = useDispatch();
  const { userGroupList, organizationList } = useSelector(
    (state) => state.user
  );

  const { t } = useTranslation("user");
  const userGroupPermission = userPermission?.userGroup;
  const userRolePermission = userPermission?.user;

  const [anchorEl, setAnchorEl] = useState(null);

  const [openForceLogout, setOpenForceLogout] = useState(false);

  const [openEdit, setOpenEdit] = useState(false);

  const [openDelete, setOpenDelete] = useState(false);

  const open = Boolean(anchorEl);

  const handleClickOpenForceLogout = () => setOpenForceLogout(true);

  const handleClickCloseForceLogout = () => setOpenForceLogout(false);

  const handleClickOpenEdit = () => {
    if (userRole === Role.Admin && user.type === Role.Admin) {
      dispatch({ type: SET_ERROR_PROMPT_USER_PAGE, payload: true });
      dispatch({
        type: SET_ERROR_MESSAGE_USER_PAGE,
        payload: t("item.errNoPermission"),
      });
    } else setOpenEdit(true);
  };

  const handleClickCloseEdit = () => setOpenEdit(false);

  const handleClickOpenDelete = () => setOpenDelete(true);

  const handleClickCloseDelete = () => setOpenDelete(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const userGroupName = useMemo(() => {
    return userGroupList[user.userGroupId]?.name ?? "-";
  }, [user, userGroupList]);

  const organizationName = useMemo(() => {
    return organizationList[user.organizationId]?.name ?? "-";
  }, [user, organizationList]);

  return (
    <StyledTableRow>
      <TableCell align="center">{index + 1}</TableCell>
      <TableCell align="left">{user.name}</TableCell>
      <TableCell align="center">{user.type}</TableCell>
      {userGroupPermission?.read && (
        <TableCell align="center">{userGroupName}</TableCell>
      )}

      {userRole === Role.Eins && (
        <TableCell align="center">{organizationName}</TableCell>
      )}

      <TableCell align="right">
        {userRole === Role.Eins ||
        userRole === Role.Admin ||
        userRolePermission?.update ||
        userRolePermission?.delete ? (
          <>
            <IconButton
              sx={{ color: colorStyling.black }}
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <MoreHorizIcon fontSize="small" />
            </IconButton>

            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {(userRole === Role.Eins ||
                userRolePermission?.update ||
                userRole === Role.Admin) && (
                <MenuItem onClick={handleClickOpenEdit} dense>
                  <EditOutlinedIcon fontSize="small" sx={{ mr: "5px" }} />
                  {t("item.editUserBtn")}
                </MenuItem>
              )}
              <EditUser
                open={openEdit}
                onClose={handleClickCloseEdit}
                user={user}
              />

              {(userRole === Role.Eins ||
                userRolePermission?.update ||
                userRole === Role.Admin) && (
                <MenuItem
                  sx={{ color: red[600] }}
                  onClick={handleClickOpenForceLogout}
                  dense
                >
                  <LogoutOutlinedIcon fontSize="small" sx={{ mr: "5px" }} />
                  {t("item.forceLogoutBtn")}
                </MenuItem>
              )}
              <ForceLogoutUser
                user={user}
                open={openForceLogout}
                onClose={handleClickCloseForceLogout}
              />

              {(userRole === Role.Eins ||
                userRolePermission?.delete ||
                userRole === Role.Admin) && (
                <MenuItem
                  sx={{ color: red[600] }}
                  onClick={handleClickOpenDelete}
                  dense
                >
                  <DeleteOutlinedIcon fontSize="small" sx={{ mr: "5px" }} />
                  {t("item.removeUserBtn")}
                </MenuItem>
              )}
              <DeleteUser
                open={openDelete}
                onClose={handleClickCloseDelete}
                user={user}
              />
            </Menu>
          </>
        ) : (
          <IconButton disabled={true}>
            <MoreHorizIcon fontSize="small" />
          </IconButton>
        )}
      </TableCell>
    </StyledTableRow>
  );
};

export default UserItem;
